import React from 'react'
import {CardBody} from 'reactstrap'
import GridSettingsForm from '../settings/SettingsForm'

const SettingsTab = () => {
  return (
    <CardBody>
      <GridSettingsForm afterSubmit={() => {}}/>
    </CardBody>
  )
}

export default SettingsTab



// WEBPACK FOOTER //
// ./src/components/Profile/tabs/SettingsTab.js